module.exports = __webpack_public_path__ + "img/IMG_7255.f5b43277.webp";